import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { useSetFieldValue } from "formik";
import { useEffect } from "react";
import { useDataQuery } from "../hooks/useDataModule";
import { ControlState } from "../models/flexible/control-state";
import { FlexSectionController } from "../models/flexible/flex-section-controller";
import { GeneralFieldController } from "./general-field-controller";
import { GET_BRAND_BY_QUEST } from "./queries";
import { GetBrandByQuest } from "./types/GetBrandByQuest";
import { useTranslation } from "react-i18next";
import { Maybe } from "../models/generated/graphql";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import * as Yup from "yup";
import { StatusHistorical } from "../models/flexible/status-historical";
import { renderRequiredMessage } from "../utils/render-required-message";

export class GeneralPatientIdFieldController extends GeneralFieldController {
	override mapInitialValue(value: unknown): unknown {
		return (
			value ||
			this.parent.context.startingPoint?.data[AttributeIdentifiers.PatientId as any] ||
			this.parent.context.parameters.patientId ||
			""
		);
	}

	override createValidationRule(_initialData: unknown, translation: (key: string) => string): Yup.AnySchema {
		return this.schema.attribute.validation !== StatusHistorical.Optional && !this.parent.context.noPatients
			? this.createFieldValidationRuleByDataType(translation)
					.nullable()
					.required(renderRequiredMessage(this.schema.attribute.identifier, translation))
			: this.createFieldValidationRuleByDataType(translation).nullable();
	}
	override useControlState(): ControlState {
		return "disabled";
	}
	override useControlProps(path: string): Maybe<FlexControlProps> | undefined {
		const { t } = useTranslation();

		if (this.parent.context.noPatients && this.parent.context.noPatients > 0) {
			return {
				isTranslated: true,
				emptyValuePlaceholder: t("bulk-coverage-patient-placeholder"),
			};
		}

		return null;
	}

	renderAfterContent(path: string) {
		return <QuestsPrefilledEffect path={path} section={this.parent} />;
	}
}

function QuestsPrefilledEffect(props: { path: string; section: FlexSectionController }) {
	const questId = props.section.context.parameters.questId;
	const setFieldValue = useSetFieldValue();
	const { data, error } = useDataQuery<GetBrandByQuest>(GET_BRAND_BY_QUEST, {
		variables: { id: questId },
		skip: !questId,
	});

	if (error) console.error(error);

	useEffect(() => {
		const quest = data?.quests[0];
		if (quest) {
			setFieldValue("preparations", [
				{ [AttributeIdentifiers.BrandName]: [{ __typename: quest?.brand?.__typename, Name: quest?.brand?.Name }] },
			]);
		}
	}, [data]);

	return null;
}
